<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa fa-map-signs" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="udf_actionAdd">{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col lg="10" xl="10">
            <b-row>
              <b-col class="col-12 mb-3">
                <!-- Backend Search -->
                  <b-form-input class="form-control"
                  @input="searchudf_actionWithParams"
                  v-model="search_param"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
                <!-- Backend Search -->
              </b-col>
              <b-col class="mb-2 col-12 col-sm-4">
                <!-- Class -->
                <select v-model="whereFilter.module_name" class="form-control" @change="setOptionFilter">
                  <option value="ORG">ORG</option>
                  <option value="UNIV">UNIV</option>
                  <option value="CLUB">CLUB</option>
                  <option value="SCH">SCH</option>
                  <option value="SAASORG">SAASORG</option>
                </select><!-- Class -->
              </b-col>
            </b-row>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="udf_actionObjList && udf_actionObjList.length > 0">
            <b-table
              hover
              responsive
              :items="udf_actionObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
            >
              <template v-slot:cell(created_on)="data">
                {{data.item.created_on | dateFormat}}
              </template>
              <template v-slot:cell(action)="data">
                <b-button variant=" iq-bg-success mr-1 mb-1" size="sm" @click="udf_actionEdit('MODAL', data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0"></i></b-button>
                <b-button variant=" iq-bg-danger" @click="showUdf_actionDeleteDialog(data.item)" size="sm"><i class="ri-delete-bin-line m-0"></i></b-button>
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
          <b-col sm="12" md="12" class="my-1">
            <b-row>
              <b-col sm="12" md="7">
                <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
              </b-col>
            </b-row>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelUdf_actionAdd"
      scrollable
      :title="cvAddModalHeader"
    >
      <UdfActionAdd :propOpenedInModal="true" @emitCloseUdf_actionAddModal="closeUdf_actionAddModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="udf_actionAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeUdf_actionAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelUdf_actionEdit"
      scrollable
      :title="cvEditModalHeader"
    >
      <UdfActionEdit :propOpenedInModal="true" :propUdf_actionObj="udf_actionEditObj" @emitCloseUdf_actionEditModal="closeUdf_actionEditModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="udf_actionEdit('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeUdf_actionEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelUdf_actionDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelUdf_actionDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="udf_actionDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { UdfActions } from "../../../FackApi/api/udfAction.js"
import UdfActionAdd from "./UdfActionAdd"
import UdfActionEdit from "./UdfActionEdit"
import moment from "moment"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"

export default {
  name: "Udf_actionList",
  components: {
    UdfActionAdd,
    UdfActionEdit
  },
  data () {
    return {
      cvCardTitle: "Allowed Actions",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit Allowed Actions",
      cvAddModalHeader: "Add Allowed Actions",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Allowed Actions",
      showModelUdf_actionAdd: false,
      showModelUdf_actionEdit: false,
      showModelUdf_actionDelete: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "action name ", key: "action_name", class: "text-left align-text-top", sortable: true },
        { label: "api name", key: "api_name", class: "text-left align-text-top", sortable: true },
        { label: "module name", key: "module_name", class: "text-left align-text-top", sortable: true },
        { label: "Created On ", key: "created_on", class: "text-left align-text-top", sortable: true },
        { label: "Action ", key: "action", class: "text-left align-text-top", sortable: false }
      ],
      udf_actionObjList: [],
      udf_actionEditObj: null,
      filter: null,
      filterOn: [],
      currentPage: 1,
      perPage: 200,
      delObj: null,
      search_param: "",
      showLoadMoreBtn: true,
      whereFilter: {
        search_param: null,
        module_name: "ORG"
      }
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    this.udf_actionList()
  },
  methods: {
    /**
     * setOptionFilter
    */
    async setOptionFilter () {
      this.udf_actionList()
    },
    /**
     * searchudf_actionWithParams
     */
    async searchudf_actionWithParams () {
      if (this.whereFilter.search_param.length == 0) {
        this.showLoadMoreBtn = true
      }
      this.udf_actionList()
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.udf_actionList(true)
    },
    /**
     * udf_actionList
     */
    async udf_actionList (loadViaLoadMore = false) {
      try {
        // setting data for pagination
        this.whereFilter.search_param = this.search_param

        let udfActionListResp = await UdfActions.udf_actionList(this, this.whereFilter)
        if (udfActionListResp.resp_status) {
          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.udf_actionObjList = [ ...udfActionListResp.resp_data.data ]
          }
          else {
            this.udf_actionObjList = [ ...this.udf_actionObjList, ...udfActionListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true

          // Adding the serial numbers:
          this.udf_actionObjList.forEach((s, index) => { s.id = index + 1 })
        }
        else {
          this.showLoadMoreBtn = false
          this.toastMsg = udfActionListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at udf_actionList() and Exception:", err)
      }
    },
    /**
     * udf_actionAdd
     */
    udf_actionAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/udf_action_add")
        }
        else {
          this.showModelUdf_actionAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at udf_actionAdd() and Exception:", err.message)
      }
    },
    /**
     * udf_actionEdit
     */
    udf_actionEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/udf_action_edit/" + this.udf_actionEditObj.action_id)
        }
        else {
          this.udf_actionEditObj = item
          this.showModelUdf_actionEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at udf_actionEdit() and Exception:", err.message)
      }
    },
    /**
     * showUdf_actionDeleteDialog
     */
    showUdf_actionDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelUdf_actionDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showUdf_actionDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * udf_actionDelete
     */
    async udf_actionDelete () {
      try {
        let udfActionDelResp = await UdfActions.udf_actionDelete(this, this.delObj.action_id)
        await ApiResponse.responseMessageDisplay(this, udfActionDelResp)

        if (udfActionDelResp && !udfActionDelResp) {
          this.showModelUdf_actionDelete = false
          return false
        }

        let index = this.udf_actionObjList.indexOf(this.delObj)
        this.udf_actionObjList.splice(index, 1)
        this.showModelUdf_actionDelete = false
      }
      catch (err) {
        console.error("Exception occurred at udf_actionDelete() and Exception:", err.message)
      }
    },
    /**
     * closeUdf_actionAddModal
     */
    closeUdf_actionAddModal (udfActionAddData) {
      try {
        if (udfActionAddData) {
          if (this.udf_actionObjList && this.udf_actionObjList.length >= 1) {
            let udfActionObjLength = this.udf_actionObjList.length
            let lastId = this.udf_actionObjList[udfActionObjLength - 1]["id"]
            udfActionAddData.id = lastId + 1
          }
          else {
            this.udf_actionObjList = []
            udfActionAddData.id = 11111
          }

          udfActionAddData.created_on = moment()
          this.udf_actionObjList.unshift(udfActionAddData)
        }

        this.showModelUdf_actionAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closeudf_actionAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeUdf_actionEditModal
     */
    closeUdf_actionEditModal () {
      try {
        this.showModelUdf_actionEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeUdf_actionEditModal() and Exception:", err.message)
      }
    }
  }
}
</script>
